export type SgpIdBetResult = "Won" | "Lost" | "Push" | "Pending";
export type SgpIdBetStatus = "Won" | "Lost" | "Pending" | "Push";
export type SgpIdBetStatusFilter = "won" | "lost" | "pending" | "pushed";

export interface SgpIdBetSelection {
  label: string;
  value: string;
  odds: string;
  result: SgpIdBetResult;
  voided?: boolean;
}

export interface SgpIdBetRow {
  id: string;
  player: string;
  dateTime: string;
  sport: string;
  league: string;
  sgpId: string;
  moneyType?: string;
  betAmount: number;
  winAmount: number;
  status: SgpIdBetStatus;
  overallOddsValue: number;
  overallOddsDisplay: string;
  selections: SgpIdBetSelection[];
}

export const SGP_ID_BETS_LIST_STATUS_OPTIONS: Array<{
  label: string;
  value: SgpIdBetStatusFilter;
}> = [
  { label: "Won", value: "won" },
  { label: "Lost", value: "lost" },
  { label: "Pending", value: "pending" },
  { label: "Pushed", value: "pushed" },
];

type SgpIdBetTemplate = Omit<SgpIdBetRow, "id" | "sgpId">;

const ROW_TEMPLATES: SgpIdBetTemplate[] = [
  {
    player: "BetMaster",
    dateTime: "19 September 2025, 12:34:00",
    sport: "Football",
    league: "NFL",
    betAmount: 5000,
    winAmount: 0,
    status: "Lost",
    overallOddsValue: 1230,
    overallOddsDisplay: "(+1230)",
    selections: [
      {
        label: "Passing TDs [OVER]",
        value: "D. Maye +1.5 Pass TDs",
        odds: "+210",
        result: "Won",
      },
      {
        label: "Passing Yards [OVER]",
        value: "D. Maye +220.5 Pass yds",
        odds: "+210",
        result: "Lost",
      },
      {
        label: "Team to Win",
        value: "NE",
        odds: "+210",
        result: "Push",
        voided: true,
      },
      {
        label: "Touchdown Scorer",
        value: "S. Diggs",
        odds: "+400",
        result: "Pending",
      },
    ],
  },
  {
    player: "JohnHopkins",
    dateTime: "19 September 2025, 12:34:00",
    sport: "Football",
    league: "NFL",
    betAmount: 50,
    winAmount: 1500,
    status: "Won",
    overallOddsValue: 1230,
    overallOddsDisplay: "(+1230)",
    selections: [
      {
        label: "Passing TDs [OVER]",
        value: "J. Herbert +2.5",
        odds: "-110",
        result: "Won",
      },
      {
        label: "Passing Yards [OVER]",
        value: "J. Herbert +190.5",
        odds: "+110",
        result: "Won",
      },
      {
        label: "Team to Win",
        value: "LAC",
        odds: "+210",
        result: "Won",
      },
      {
        label: "Touchdown Scorer",
        value: "Q. Johnston",
        odds: "+400",
        result: "Won",
      },
    ],
  },
  {
    player: "SharpPlay21",
    dateTime: "20 September 2025, 15:05:00",
    sport: "Football",
    league: "NFL",
    betAmount: 50,
    winAmount: 1500,
    status: "Won",
    overallOddsValue: 860,
    overallOddsDisplay: "(+860)",
    selections: [
      {
        label: "Passing TDs [OVER]",
        value: "B. Purdy +2.5",
        odds: "+155",
        result: "Won",
      },
      {
        label: "Passing Yards [OVER]",
        value: "B. Purdy +275.5",
        odds: "+100",
        result: "Lost",
      },
      {
        label: "Team to Win",
        value: "SF",
        odds: "-120",
        result: "Won",
      },
      {
        label: "Touchdown Scorer",
        value: "G. Kittle",
        odds: "+300",
        result: "Lost",
      },
    ],
  },
  {
    player: "LunaBets",
    dateTime: "20 September 2025, 18:10:00",
    sport: "Football",
    league: "NFL",
    betAmount: 50,
    winAmount: 1500,
    status: "Won",
    overallOddsValue: 410,
    overallOddsDisplay: "(+410)",
    selections: [
      {
        label: "Passing TDs [OVER]",
        value: "C. Williams +1.5",
        odds: "+145",
        result: "Push",
        voided: true,
      },
      {
        label: "Passing Yards [OVER]",
        value: "C. Williams +230.5",
        odds: "-105",
        result: "Won",
      },
      {
        label: "Team to Win",
        value: "CHI",
        odds: "+130",
        result: "Push",
        voided: true,
      },
      {
        label: "Touchdown Scorer",
        value: "D. Swift",
        odds: "+240",
        result: "Won",
      },
    ],
  },
];

export function buildSgpIdBetsListRows(sgpId: string): SgpIdBetRow[] {
  return Array.from({ length: 24 }, (_, index) => {
    const template = ROW_TEMPLATES[index % ROW_TEMPLATES.length];
    return {
      ...template,
      id: `sgp-id-bet-${index + 1}`,
      sgpId,
      selections: template.selections.map((selection) => ({ ...selection })),
    };
  });
}
